module.exports = __webpack_public_path__ + "static/logorec-0bbd4b713da0debda94e5a997751a00b.svg";